//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      sheetVisible: false,
      sheetVisible2: false,
      actions: [],
      actions2: []
    };
  },

  methods: {
    takePhoto() {
      console.log('taking photo');
    },

    openAlbum() {
      console.log('opening album');
    },

    goBack() {
      history.go(-1);
    }
  },

  mounted() {
    this.actions = [{
      name: '拍照',
      method: this.takePhoto
    }, {
      name: '从相册中选择',
      method: this.openAlbum
    }];
    this.actions2 = [{
      name: '确定'
    }, {
      name: '返回上一步',
      method: this.goBack
    }];
  }
};



// WEBPACK FOOTER //
// ./example/pages/action-sheet.vue